<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.editDepartment.title' | translate }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isLoading"></app-spinner>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="row g-3 mb-3">
          <div class="col-md-8">
            <label class="form-label lna" for="name">
              {{ 'components.editDepartment.name' | translate }}
              <span class="text-danger fw-bold">*</span>
            </label>
            <input
              class="form-control lna"
              id="name"
              [ngClass]="{
                invalid: this.shouldRenderError('name') && name?.errors
              }"
              formControlName="name"
              type="text"
              name="name" />
            @if (this.shouldRenderError('name') && name?.errors) {
              @if (name?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (name?.errors?.['minlength']) {
                <small class="error-message">
                  {{ 'components.form.minLength' | translate: { name: name?.errors?.['minlength']['requiredLength'] } }}
                </small>
              } @else if (name?.errors?.['maxlength']) {
                <small class="error-message">
                  {{
                    'components.form.maxLength'
                      | translate
                        : {
                            maxLength: name?.errors?.['maxlength']['requiredLength']
                          }
                  }}
                </small>
              }
            }
          </div>
          <div class="col-md-4">
            <label class="form-label lna" for="code">
              {{ 'components.editDepartment.code' | translate }}
              <span class="text-danger fw-bold">*</span>
            </label>
            <input
              class="form-control lna"
              id="code"
              [ngClass]="{
                invalid: this.shouldRenderError('code') && code?.errors
              }"
              formControlName="code"
              type="text"
              name="code" />
            @if (this.shouldRenderError('code') && code?.errors) {
              @if (code?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (code?.errors?.['minlength']) {
                <small class="error-message">
                  {{ 'components.form.minLength' | translate: { name: code?.errors?.['minlength']['requiredLength'] } }}
                </small>
              } @else if (code?.errors?.['maxlength']) {
                <small class="error-message">
                  {{
                    'components.form.maxLength'
                      | translate
                        : {
                            maxLength: code?.errors?.['maxlength']['requiredLength']
                          }
                  }}
                </small>
              }
            }
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-md-6">
            <label class="form-label lna" for="phone">
              {{ 'components.editDepartment.phone' | translate }}
              <span class="text-danger fw-bold">*</span>
            </label>
            <input
              class="form-control lna"
              id="phone"
              [ngClass]="{
                invalid: this.shouldRenderError('phone') && phone?.errors
              }"
              formControlName="phone"
              type="text"
              name="phone" />
            @if (this.shouldRenderError('phone') && phone?.errors) {
              @if (phone?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (phone?.errors?.['invalidPhone']) {
                <small class="error-message">
                  {{ 'components.form.invalidPhone' | translate }}
                </small>
              } @else if (phone?.errors?.['minlength']) {
                <small class="error-message">
                  {{ 'components.form.minLength' | translate: { minLength: phone?.errors?.['minlength']['requiredLength'] } }}
                </small>
              } @else if (phone?.errors?.['maxlength']) {
                <small class="error-message">
                  {{ 'components.form.maxLength' | translate: { maxLength: phone?.errors?.['maxlength']['requiredLength'] } }}
                </small>
              }
            }
          </div>
          <div class="col-md-6">
            <label class="form-label lna" for="email">
              {{ 'components.editDepartment.email' | translate }}
              <span class="text-danger fw-bold">*</span>
            </label>
            <input
              class="form-control lna"
              id="email"
              [ngClass]="{
                invalid: this.shouldRenderError('email') && email?.errors
              }"
              formControlName="email"
              type="text"
              name="email" />
            @if (this.shouldRenderError('email') && email?.errors) {
              @if (email?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (email?.errors?.['invalidEmail']) {
                <small class="error-message">
                  {{ 'components.form.invalidEmail' | translate }}
                </small>
              } @else if (email?.errors?.['minlength']) {
                <small class="error-message">
                  {{ 'components.form.minLength' | translate: { minLength: email?.errors?.['minlength']['requiredLength'] } }}
                </small>
              } @else if (email?.errors?.['maxlength']) {
                <small class="error-message">
                  {{ 'components.form.maxLength' | translate: { maxLength: email?.errors?.['maxlength']['requiredLength'] } }}
                </small>
              }
            }
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-md-6">
            <label class="form-label lna" for="address">
              {{ 'components.editDepartment.address' | translate }}
              <span class="text-danger fw-bold">*</span>
            </label>
            <input
              class="form-control lna"
              id="address"
              [ngClass]="{
                invalid: this.shouldRenderError('address') && address?.errors
              }"
              formControlName="address"
              type="text"
              name="address" />
            @if (this.shouldRenderError('address') && address?.errors) {
              @if (address?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (address?.errors?.['maxlength']) {
                <small class="error-message">
                  {{ 'components.form.maxLength' | translate: { maxLength: address?.errors?.['maxlength']['requiredLength'] } }}
                </small>
              }
            }
          </div>
          <div class="col-md-6">
            <label class="form-label lna" for="applicationEmail">
              {{ 'components.editDepartment.applicationEmail' | translate }}
              <span class="text-danger fw-bold">*</span>
            </label>
            <input
              class="form-control lna"
              id="applicationEmail"
              [ngClass]="{
                invalid: this.shouldRenderError('applicationEmail') && applicationEmail?.errors
              }"
              formControlName="applicationEmail"
              type="text"
              name="applicationEmail" />
            @if (this.shouldRenderError('applicationEmail') && applicationEmail?.errors) {
              @if (applicationEmail?.errors?.['required']) {
                <small class="error-message">
                  {{ 'components.form.errorRequired' | translate }}
                </small>
              } @else if (applicationEmail?.errors?.['invalidEmail']) {
                <small class="error-message">
                  {{ 'components.form.invalidEmail' | translate }}
                </small>
              } @else if (applicationEmail?.errors?.['minlength']) {
                <small class="error-message">
                  {{ 'components.form.minLength' | translate: { minLength: applicationEmail?.errors?.['minlength']['requiredLength'] } }}
                </small>
              } @else if (applicationEmail?.errors?.['maxlength']) {
                <small class="error-message">
                  {{ 'components.form.maxLength' | translate: { maxLength: applicationEmail?.errors?.['maxlength']['requiredLength'] } }}
                </small>
              }
            }
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-12">
            <div class="form-check">
              <input
                class="form-check-input lna checkbox"
                id="isDefaultStructureForIncomingDocuments"
                type="checkbox"
                formControlName="isDefaultStructureForIncomingDocuments" />
              <label class="form-check-label" for="isDefaultStructureForIncomingDocuments">
                {{ 'components.editDepartment.isDefaultStructureForIncomingDocuments' | translate }}
              </label>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isLoading" (click)="handleSave()" type="button">
      {{ 'components.editDepartment.save' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.editDepartment.cancel' | translate }}
    </button>
  </div>
</ng-template>

<button [ngClass]="{ secondary: isParent, 'open-button': !isParent }" (click)="open(content)">
  <img src="assets/images/edit-icon.svg" alt="edit" />
  {{ 'components.editDepartment.edit' | translate }}
</button>
